// Opens (or creates) the one conversation between an organization and a member worker, for the
// OrganizationDashboard Members tab "Message" button. Mirrors startConversationWithUnion, with
// one difference: the database allows only one conversation per (organization_id, worker_id),
// so a thread the organization had hidden is un-hidden and reused rather than recreated.
//
// RLS lets organization staff see/create these only while the worker is a current member
// (organization_members.left_at is null).
export async function startConversationWithOrganization(supabase, workerId, organizationId) {
  const findExisting = () => supabase
    .from('conversations')
    .select('id, organization_hidden_at')
    .eq('worker_id', workerId)
    .eq('organization_id', organizationId)
    .limit(1)
    .maybeSingle();

  const { data: existing, error: lookupError } = await findExisting();
  if (lookupError) {
    console.error('[startConversationWithOrganization] Lookup error:', lookupError);
    return null;
  }
  if (existing) {
    if (existing.organization_hidden_at) {
      await supabase.from('conversations').update({ organization_hidden_at: null }).eq('id', existing.id);
    }
    return existing.id;
  }

  const { data: created, error } = await supabase
    .from('conversations')
    .insert({ worker_id: workerId, organization_id: organizationId, conversation_type: 'worker_organization' })
    .select('id')
    .single();
  if (error) {
    // Two staff members (or two clicks) creating it at the same moment: the unique
    // (organization_id, worker_id) constraint refuses the second insert -- use the row that won.
    if (error.code === '23505') {
      const { data: winner } = await findExisting();
      if (winner) return winner.id;
    }
    console.error('[startConversationWithOrganization] Insert error:', error);
    return null;
  }
  return created?.id || null;
}
